module.exports = function getResource(label, vars = []) {
    const resources = {
        createANickname: '[ Créer un surnom ]',
        tapToSee: 'Touchez pour voir',
        clickToSee: 'Cliquez pour voir',
        thisMembersFollowers: 'voir les abonnés de ce membre et qui il suit!',
        following: 'suivis',
        follower: 'abonné',
        followers: 'abonnés',
        gotIt: 'Compris',
        userProfileMessage: `<b>${vars[0] ? ' Cliquez' : ' pour'} voir</b> vos abonnés et qui vous suivez!`,
        otherUserProfileMessage: `<b>${vars[0] ? ' Cliquez' : ' pour'} voir</b> les abonnés de ce membre et qui il suit!`
    };
    return resources[label];
};
